"use strict";
/**
 * @license
 * Copyright Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlToNode = exports.svgFragment = exports.htmlFragment = void 0;
require("../environment/dev.js");
const html_impl_js_1 = require("../internals/html_impl.js");
const string_literal_js_1 = require("../internals/string_literal.js");
/**
 * Creates a DocumentFragment object from a template literal (without any
 * embedded expressions) using the document context (HTML).
 *
 * Note: use svgFragment instead to create a DocumentFragment belonging to the
 * SVG namespace.
 *
 * This function is a template literal tag function. It should be called with
 * a template literal that does not contain any expressions. For example,
 *                           htmlFragment`foo`;
 *
 * @param templateObj This contains the literal part of the template literal.
 */
function htmlFragment(templateObj) {
    if (process.env.NODE_ENV !== 'production') {
        (0, string_literal_js_1.assertIsTemplateObject)(templateObj, 0);
    }
    const range = document.createRange();
    return range.createContextualFragment((0, html_impl_js_1.unwrapHtml)((0, html_impl_js_1.createHtmlInternal)(templateObj[0])));
}
exports.htmlFragment = htmlFragment;
/**
 * Creates a DocumentFragment object from a template literal (without any
 * embedded expressions), with an SVG context.
 *
 * This function is a template literal tag function. It should be called with
 * a template literal that does not contain any expressions. For example,
 *                           svgFragment`foo`;
 *
 * @param templateObj This contains the literal part of the template literal.
 */
function svgFragment(templateObj) {
    if (process.env.NODE_ENV !== 'production') {
        (0, string_literal_js_1.assertIsTemplateObject)(templateObj, 0);
    }
    const svgElem = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const range = document.createRange();
    range.selectNodeContents(svgElem);
    return range.createContextualFragment((0, html_impl_js_1.unwrapHtml)((0, html_impl_js_1.createHtmlInternal)(templateObj[0])));
}
exports.svgFragment = svgFragment;
/** Converts HTML markup into a node. */
function htmlToNode(html) {
    const range = document.createRange();
    const fragment = range.createContextualFragment((0, html_impl_js_1.unwrapHtml)(html));
    if (fragment.childNodes.length === 1) {
        return fragment.childNodes[0];
    }
    else {
        return fragment;
    }
}
exports.htmlToNode = htmlToNode;
